'use client';

import { useProductSearchBox } from '@dealerportal/react-helpers';
import dynamic from 'next/dynamic';
import { ProductSearchBoxSkeleteon } from './skeletons/ProductSearchBoxSkeleton';

type ProductSearchBoxRendererProps = {
  isMobileDevice: boolean;
};

export const ProductSearchBoxDialogLoader = (
  props: ProductSearchBoxRendererProps
) => {
  const ctx = useProductSearchBox();
  const ProductSearchBoxDialog = dynamic(
    () => import('./ProductSearchBoxDialog'),
    {
      loading: () => (
        <ProductSearchBoxSkeleteon isMobileDevice={props.isMobileDevice} />
      ),
    }
  );

  if (!ctx?.loaded) return null;

  return <ProductSearchBoxDialog isMobileDevice={props.isMobileDevice} />;
};
